<template>
  <div :id="componentId" class="sp3-module-3" :style="moduleStyle">
    <div class="sp3-content-inner">
      <div class="sp3-left-section">
        <div class="sp3-section-title">{{ leftTitle || '公告通知' }}</div>
        <div class="sp3-notice-list">
          <div
            v-for="(item, index) in displayLeftList"
            :key="index"
            class="sp3-notice-item"
            @click="goTo(item.url)"
          >
            <div class="sp3-notice-item-title">{{ item.title || '文章标题' }}</div>
            <div class="sp3-notice-item-summary">{{ item.summary || '文章摘要' }}</div>
          </div>
        </div>
      </div>

      <div class="sp3-right-section">
        <div class="sp3-section-title">{{ rightTitle || '聚焦两会' }}</div>
        <div class="sp3-focus-list">
          <div
            v-for="(item, index) in displayRightList"
            :key="index"
            class="sp3-focus-item"
            :class="{ first: index === 0 }"
            @click="goTo(item.url)"
          >
            <template v-if="index === 0">
              <div class="sp3-focus-image-wrap">
                <img
                  v-if="item.imageUrl"
                  class="sp3-focus-image"
                  referrerpolicy="no-referrer"
                  :src="item.imageUrl"
                >
                <div v-else class="sp3-focus-image-placeholder">图片</div>
              </div>
              <div class="sp3-focus-first-text">
                <div class="sp3-focus-first-title">{{ item.title || '文章标题' }}</div>
                <div class="sp3-focus-first-summary">{{ item.summary || '文章摘要' }}</div>
              </div>
            </template>
            <template v-else>
              <div class="sp3-focus-item-title">{{ item.title || '文章标题' }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_LEFT_ITEM = {
  newsCode: '',
  url: '',
  title: '2023中国品牌日 第七届中国品牌发展',
  summary: '品牌是高质量发展的重要象征，加强品牌建设是满足人民美好生活需要的重要途径。2023年5月10日是我国第7个“中国品牌日”'
}

const DEFAULT_RIGHT_ITEM = {
  imageUrl: '',
  newsCode: '',
  url: '',
  title: '十四届全国人大一次会议在京闭幕 习近平发表重要讲话',
  summary: '品牌是高质量发展的重要象征，加强品牌建设是满足人民美好生活需要的重要途径。2023年5月10日是我国第7个“中国品牌日”'
}

export default {
  name: 'SpThreeModule3',
  props: {
    componentId: {
      type: String,
      default: 'sp_three_module_3'
    }
  },
  data() {
    return {
      bgColor: '#FFFFFF',
      leftTitle: '公告通知',
      rightTitle: '聚焦两会',
      leftList: Array.from({ length: 3 }, () => ({ ...DEFAULT_LEFT_ITEM })),
      rightList: Array.from({ length: 5 }, () => ({ ...DEFAULT_RIGHT_ITEM }))
    }
  },
  computed: {
    displayLeftList() {
      return (this.leftList || []).slice(0, 3)
    },
    displayRightList() {
      return (this.rightList || []).slice(0, 5)
    },
    moduleStyle() {
      return {
        backgroundColor: this.bgColor
      }
    }
  },
  methods: {
    goTo(url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.sp3-module-3 {
  position: relative;
  width: 100%;
  padding: 32px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp3-content-inner {
  display: flex;
  flex-direction: column;
  width: calc(100% - 24px);
  margin: 0 auto;
  padding: 0;
  gap: 32px;
}

.sp3-section-title {
  font-size: 22px;
  text-align: center;
  line-height: 1.4;
  background: linear-gradient(90deg, #FB2911 0%, #930000 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sp3-left-section,
.sp3-right-section {
  width: 100%;
}

.sp3-notice-list {
  width: 100%;
  margin-top: 20px;
}

.sp3-notice-item {
  width: 100%;
  cursor: pointer;
  margin-bottom: 20px;
  transition: opacity 0.2s ease;
}

.sp3-notice-item:hover {
  opacity: 0.85;
}

.sp3-notice-item:last-child {
  margin-bottom: 0;
}

.sp3-notice-item-title {
  width: 100%;
  font-size: 16px;
  color: #333333;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sp3-notice-item-summary {
  width: 100%;
  margin-top: 8px;
  font-size: 13px;
  color: #666666;
  line-height: 1.6;
  text-align: justify;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sp3-focus-list {
  width: 100%;
  margin-top: 20px;
}

.sp3-focus-item {
  width: 100%;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.sp3-focus-item:hover {
  opacity: 0.85;
}

.sp3-focus-item.first {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 16px;
}

.sp3-focus-image-wrap {
  width: 130px;
  height: 80px;
  flex-shrink: 0;
  overflow: hidden;
  background: #E0E0E0;
  border-radius: 4px;
}

.sp3-focus-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp3-focus-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

.sp3-focus-first-text {
  flex: 1;
  margin-left: 12px;
  min-width: 0;
}

.sp3-focus-first-title {
  width: 100%;
  font-size: 15px;
  color: #343638;
  line-height: 1.4;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sp3-focus-first-summary {
  width: 100%;
  margin-top: 6px;
  font-size: 12px;
  color: #666666;
  line-height: 1.6;
  text-align: justify;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.sp3-focus-item-title {
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
  color: #343638;
  line-height: 1.5;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-bottom: 1px dashed #E5E5E5;
}

.sp3-focus-item:last-child .sp3-focus-item-title {
  border-bottom: none;
}
</style>
